module.exports = __webpack_public_path__ + "img/stream-settings.215d50b.svg";